/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelShipmentReasonAdminDto } from '../models/CancelShipmentReasonAdminDto';
import type { GetCancelShipmentReasonsPsiResponse } from '../models/GetCancelShipmentReasonsPsiResponse';
import type { PostCancelShipmentReasonRequestAdmin } from '../models/PostCancelShipmentReasonRequestAdmin';
import type { PutCancelShipmentReasonRequestAdmin } from '../models/PutCancelShipmentReasonRequestAdmin';
import type { RoleType } from '../models/RoleType';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CancelShipmentReasonsService {
    /**
     * @returns GetCancelShipmentReasonsPsiResponse OK
     * @throws ApiError
     */
    public static getCancelShipmentReasonsDriver(): CancelablePromise<GetCancelShipmentReasonsPsiResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/driver/v1/cancelshipmentreasons',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageCancelShipmentReasons`
     * @returns CancelShipmentReasonAdminDto OK
     * @throws ApiError
     */
    public static postCancelShipmentReasonAdmin({
        requestBody,
    }: {
        requestBody?: PostCancelShipmentReasonRequestAdmin,
    }): CancelablePromise<CancelShipmentReasonAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/cancelshipmentreasons',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewCancelShipmentReasons`
     * @returns GetCancelShipmentReasonsPsiResponse OK
     * @throws ApiError
     */
    public static getCancelShipmentReasonsAdmin({
        role,
    }: {
        role?: RoleType,
    }): CancelablePromise<GetCancelShipmentReasonsPsiResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/cancelshipmentreasons',
            query: {
                'role': role,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewCancelShipmentReasons`
     * @returns GetCancelShipmentReasonsPsiResponse OK
     * @throws ApiError
     */
    public static getSimplifiedCancelShipmentReasonsAdmin(): CancelablePromise<GetCancelShipmentReasonsPsiResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/cancelshipmentreasons/simplified',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewCancelShipmentReasons`
     * @returns CancelShipmentReasonAdminDto OK
     * @throws ApiError
     */
    public static getCancelShipmentReasonAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<CancelShipmentReasonAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/cancelshipmentreasons/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageCancelShipmentReasons`
     * @returns CancelShipmentReasonAdminDto OK
     * @throws ApiError
     */
    public static putCancelShipmentReasonAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutCancelShipmentReasonRequestAdmin,
    }): CancelablePromise<CancelShipmentReasonAdminDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/cancelshipmentreasons/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `DeleteCancelShipmentReasons`
     * @returns any OK
     * @throws ApiError
     */
    public static deleteCancelShipmentReasonAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/cancelshipmentreasons/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
